import { render, staticRenderFns } from "./EmSppStorageInfoStiMove.vue?vue&type=template&id=68e4d852&"
import script from "./EmSppStorageInfoStiMove.vue?vue&type=script&lang=js&"
export * from "./EmSppStorageInfoStiMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports